import React from 'react';
import KanameRaanaFanPage from '../components/KanameRaanaFanPage';

// Main page component for Kaname Raana fan page
const KanamePage: React.FC = () => {
  return <KanameRaanaFanPage />;
};

export default KanamePage;